import type { Session } from "next-auth";

import { PageTypeAdmin, PageTypePortal } from "@/lib/types";
import type { AppUser } from "@/lib/types/next-auth";
import { isSessionHealthyForAutoRedirect } from "@/lib/utils/auth/sessionHealth";
import { hasAnyAdminRole } from "@/lib/utils/roles";
import { getPostAuthRedirectPath } from "../auth/postAuthRedirect";

export function getDashboardRouteForUser(user: AppUser | null | undefined): string {
  if (user?.isMember) return PageTypePortal.Dashboard;
  if (hasAnyAdminRole(user)) return PageTypeAdmin.Dashboard;
  return PageTypePortal.Login;
}

/** Where to send an already-authenticated user hitting portal entry routes (/, sign-in). */
export function resolveAuthenticatedUserLanding(
  session: Session | null | undefined,
  callbackUrl?: string | null,
): string | null {
  if (!isSessionHealthyForAutoRedirect(session)) return null;

  const user = session!.user as AppUser;
  const fallback = getDashboardRouteForUser(user);
  if (fallback === PageTypePortal.Login) return null;

  if (callbackUrl != null) {
    return getPostAuthRedirectPath(callbackUrl, fallback);
  }

  return fallback;
}
